import tippy from 'tippy.js';

$(function(){
	if ($('.tippy').length > 0){
		var sContent = '<dl><dt>設置型</dt><dd>店舗の手間を掛けず広告を設置・貼付するタイプです。</dd></dl>';
		sContent += '<dl><dt>コミュニケーション型</dt><dd>店舗スタッフを介して積極的にお客様に広告を提供するタイプです。</dd></dl>';
		sContent += '<dl><dt>コラボレーション型</dt><dd>商材を店舗運営に使用したり広告を自然に馴染ませる企画型タイプです。</dd></dl>';
		sContent += '<dl class="mb-0"><dt>エクスペリエンス提供型</dt><dd>お客様に商材を見て触って楽しんでもらうタイプです。</dd></dl>';
		tippy('.tippy.category-exp', {
			arrow: true,
			animation: 'fade',
			content: sContent,
		});
	}
});